import { render, staticRenderFns } from "./NisSurvey.vue?vue&type=template&id=f18db2a6&scoped=true"
import script from "./NisSurvey.vue?vue&type=script&lang=js"
export * from "./NisSurvey.vue?vue&type=script&lang=js"
import style0 from "./NisSurvey.vue?vue&type=style&index=0&id=f18db2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18db2a6",
  null
  
)

export default component.exports